<template>
  <div class="row">
    <div class="col-12 mb-3">
      <select v-model="selectedLang" class="lang-selector form-control mb-2">
        <option v-for="lang in langs" :key="lang.code" :value="lang">{{ lang.code }}</option>
      </select>
      <div class="search">
        <input v-model="searchQuery" class="form-control" type="text" placeholder="search..." @input="runSearch">

        <button class="btn btn-outline-primary btn-stop-search" @click="stopSearch">
          <fa :icon="['fas', 'times']" />
        </button>
      </div>
    </div>

    <div class="col-12">
      <card title="List of Pages">
        <div v-if="userAccess.indexOf('pagesCreate') !== -1" class="row mb-5">
          <div class="col-12">
            <router-link class="btn btn-primary" to="/pages/new">Add new page</router-link>
          </div>
        </div>

        <table class="table">
          <thead> 
            <th 
              v-for="column in ['heading', 'description', 'category', 'type', 'section', 'actions']" :key="column" 
              class="column" 
              :class="[{'active' : sortedType === column}, column]" 
              @click="['actions', 'section'].indexOf(column) === -1 ? sortBy(column) : null"
            >
              {{column}} <fa v-if="sortedType === column && column !=='actions'" class="arrow" :class="{'fa-rotate-180': isSortReversed && sortedType === column}" :icon="['fa', 'chevron-down']" />
            </th>
          </thead>
          <tbody>
            <tr v-for="(item, index) in displayList" :key="'row' + index">

              <td v-for="(column, index) in ['heading', 'description', 'category', 'type', 'section', 'actions']" :key="'col' + index">

                <div 
                  v-if="column === 'category'" 
                  :class="`table__cell table__cell--${item[column.toLowerCase()]} badge p-2`"
                >{{ item.navigationCategoryName[selectedLang.code] }}</div>

                <div 
                  v-if="column === 'type'" 
                  :class="`table__cell table__cell--${item[column.toLowerCase()]} badge p-2`" v-html="transformToStartCase(item[column.toLowerCase()])"
                ></div>

                <div v-else :class="`table__cell table__cell--${column.toLowerCase()}`" v-html="item[column.toLowerCase()] && selectedLang ? item[column.toLowerCase()][selectedLang.code] : item[column.toLowerCase()]"></div>

                <router-link
                  v-if="column === 'actions' && userAccess.indexOf('pagesEdit') !== -1"
                  :to="'/pages/' + item._id"
                  class="btn btn-sm btn-outline-secondary"
                >
                  Edit
                </router-link>

                <button 
                  v-if="column === 'actions' && userAccess.indexOf('pagesDelete') !== -1"
                  class="btn btn-sm btn-outline-danger mx-2"
                  @click="deletePage(item._id)"
                >
                  Delete
                </button>

                <div 
                  v-if="column === 'section'" 
                  v-html="getUsedByNavItems(item._id)"
                ></div>
              </td>

            </tr>
          </tbody>
        </table>
      </card>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import store from '@/store'
import { FETCH_NAVIGATION, FETCH_PAGES, PAGE_DELETE } from '@/store/actions.type'
import Swal from 'sweetalert2'
import _ from 'lodash'

export default {

  name: "Pages",

  data() {
    return {
      isShowingSearchResults: false,
      isSortReversed: true,
      searchQuery: '',
      searchResults: [],
      selectedLang: { code: "en", rtl: false },
      sorted: [],
      sortedType: 'heading'
    }
  },

  computed: {
    ...mapGetters([
      "pages",
      "navigation",
      "langs"
    ]),

    displayList() {
      if (this.isShowingSearchResults) {
        return this.searchResults
      } else {
        return this.sorted
      }
    },

    selectedLangCode () {
      return this.selectedLang.code
    },

    userAccess () {
      return this.$store.getters.user.access ? this.$store.getters.user.access : []
    }
  },

  beforeMount() {
    this.$store.dispatch(FETCH_PAGES)
      .then(res => {
        if (_.isEmpty(res)) {
          this.$notify({
            message: 'No pages found',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'warning'
          });
        }
        this.sortBy(this.sortedType)
        this.searchResults = res
      })

    this.$store.dispatch(FETCH_NAVIGATION)
      .then(res => {
        if (res !== null && !_.isEmpty(this.navigation.categories)) {
          this.selectedTabId = this.navigation.categories[0].id
        } else {
          this.$notify({
            message: 'No navigation items found',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'warning'
          });
        }
      })
      .catch(err => {
        this.$notify({
          message: 'Error - ' + err,
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'danger'
        });
      });
  },

  mounted() {
    let context = this
    this.$nextTick(function() {
      window.addEventListener('keyup', function(e){
        if(e.keyCode === 27) {
          context.stopSearch()
        }
      })
    })
  },

  methods: {
    deletePage(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          Swal.fire(
            'Deleted!',
            'The page has been deleted.',
            'success'
          )

          let remainingPages = _.remove(this.pages, function(page) {
            return page._id == id;
          });

          this.$store.dispatch(PAGE_DELETE, id)

          // TODO update table - better way to do this?
          this.sortReset()
        }
      })
    },

    getUsedByNavItems(pageId) {
      let usedBy = []
      let htmlString = ''

      if (this.navigation.categories) {
        this.navigation.categories.forEach(category => {
          category.children.forEach(baseItem => {
            if (baseItem.pageId === pageId) {
              if (baseItem.label[this.selectedLang.code] !== undefined) {
                usedBy.push(baseItem.label[this.selectedLang.code])
              }
            }

            baseItem.children.forEach(childItem => {
              if (childItem.pageId === pageId) {
                if (childItem.label[this.selectedLang.code] !== undefined) {
                  usedBy.push(childItem.label[this.selectedLang.code])
                }
              }
            })
          })
        })
      }
      
      usedBy.forEach(item => {
        htmlString += `<div class="badge badge-secondary ml-1">${item}</div>`
      })

      return htmlString
    },

    sortReset() {
      this.isSortReversed = !this.isSortReversed
      this.sortBy(this.sortedType)
    },

    sortBy(type) {
      this.isSortReversed = !this.isSortReversed
      this.sortedType = type
      let selectedLangCode = this.selectedLangCode
      
      switch (type) {
        case 'type':
          if (this.isSortReversed) {
            this.searchResults = _.reverse(_.sortBy(this.searchResults, ['type']))
            this.sorted = _.reverse(_.sortBy(this.pages, ['type']))
            
          } else {
            this.searchResults = _.sortBy(this.searchResults, ['type'])
            this.sorted = _.sortBy(this.pages, ['type'])
          }
          break;

        case 'heading':
          if (this.isSortReversed) {
            this.searchResults = _.reverse(_.sortBy(this.searchResults, [function(o) { return o.heading[selectedLangCode]; }]))
            this.sorted = _.reverse(_.sortBy(this.pages, [function(o) { return o.heading[selectedLangCode]; }]))
          } else {
            this.searchResults = _.sortBy(this.searchResults, [function(o) { return o.heading[selectedLangCode]; }])
            this.sorted = _.sortBy(this.pages, [function(o) { return o.heading[selectedLangCode]; }])
          }
          break;

        case 'description':
          if (this.isSortReversed) {
            this.searchResults = _.reverse(_.sortBy(this.searchResults, [function(o) { return o.description[selectedLangCode]; }]))
            this.sorted = _.reverse(_.sortBy(this.pages, [function(o) { return o.description[selectedLangCode]; }]))
          } else {
            this.searchResults = _.sortBy(this.searchResults, [function(o) { return o.description[selectedLangCode]; }])
            this.sorted = _.sortBy(this.pages, [function(o) { return o.description[selectedLangCode]; }])
          }
          break;

        case 'category':
          if (this.isSortReversed) {
            this.searchResults = _.reverse(_.sortBy(this.searchResults, [function(o) { return o.navigationCategoryName[selectedLangCode]; }]))
            this.sorted = _.reverse(_.sortBy(this.pages, [function(o) { return o.navigationCategoryName[selectedLangCode]; }]))
          } else {
            this.searchResults = _.sortBy(this.searchResults, [function(o) { return o.navigationCategoryName[selectedLangCode]; }])
            this.sorted = _.sortBy(this.pages, [function(o) { return o.navigationCategoryName[selectedLangCode]; }])
          }
          break;

        case 'used by':
          break;

        default:
          break;
      }
    },

    runSearch () {
      if (this.searchQuery.length < 2) {
        this.isShowingSearchResults = false
        return null
      }

      let results = _.cloneDeep(this.sorted)
      this.searchResults = []

      let keys = []
      let lang = this.selectedLang ? this.selectedLang.code : null

      if (lang) {
        keys = [`heading.${lang}`, `description.${lang}`]
      } else {
        keys = ['heading', 'description']
      }

      this.$search(
        this.searchQuery, 
        results, 
        { 
          keys: keys, 
          includeMatches: true, 
          minMatchCharLength: 2,
          distance: 600,
          findAllMatches: true
        }
      )
      .then(result => {
        result.forEach((element) => {
          let output = ''

          element.matches.forEach((match) => {
            const matchedString = match.value
            
            match.indices.forEach((matchPos, index) => {
              const tagStart = '<strong>'
              const tagEnd = '</strong>'
              let tagsLength = tagStart.length + tagEnd.length

              // for every loop add the string length of the added tags
              let start = matchPos[0] + (index * tagsLength) 
              let end = matchPos[1] + (index * tagsLength) + 1
  
              if (index === 0) {
                output = matchedString
              }
              
              output = output.substring(0, end) + tagEnd + output.substring(end)
              output = output.substring(0, start) + tagStart + output.substring(start)
            })

            let matchKeyArray = match.key.split('.')

            if (matchKeyArray.length === 1) {
              element.item[matchKeyArray[0]] = output
            } else if (matchKeyArray.length === 2) {
              element.item[matchKeyArray[0]][matchKeyArray[1]] = output
            }

            this.searchResults.push(element.item)
          })
        })
        
        // remove any duplicates (caused by finding matches in both heading and description)
        this.searchResults = _.uniq(this.searchResults, '_id');
        this.isShowingSearchResults = true
      })
    },

    stopSearch() {
      this.isShowingSearchResults = false
      this.searchQuery = ''
    },

    transformToStartCase (string) {
      return _.startCase(_.camelCase(string))
    },
  },

  beforeDestroy() {
    window.removeEventListener('keyup', function(){})
  }
};
</script>
<style lang="scss" scoped>

.search {
  position: relative;

  .btn-stop-search {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-color: transparent;
    font-size: 12px;
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
  }
}

.table {
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid #d4d4d4;
  border-radius: 6px;
  width: 100%;

  &__cell {
    max-height: 100px;
    max-width: 720px;
    overflow: hidden;
    position: relative;

    .badge {
      border-radius: 4px;
      display: inline-block;
      font-size: 75%;
      font-weight: 700;
      line-height: 1;
      padding: 4px 6px;
      text-align: center;
      vertical-align: baseline;
      white-space: nowrap;
    }

    &--place {
      background-color: #00d2ff;
    }

    &--events {
      background-color: #7ad900;
    }

    &--gallery {
      background-color: #ffc373;
    }

    &--interactiveTags {
      background-color: #f0ed32;
    }

    &--description {

      &::after {
        background: linear-gradient(to top, #fff, transparent);
        content: '';
        height: 50px;
        left: 0;
        position: absolute;
        right: 0;
        top: 50px;
      }
    }

    p {
      margin-bottom: 0;
    }
  }

  thead {
    background-color: #f0f0f0;
    border-bottom: 1px solid #d4d4d4;
    font-size: 12px;
    position: sticky;
    text-transform: uppercase;
    top: 0;
    z-index: 10;
  }

  th {

    &.actions {
      cursor: auto;
      width: 180px;
    }

    &.section {
      cursor: auto;
    }

    &.description {
      font-size: inherit;
    }
  }

  tr {

    td {
      border-top: none;
      border-bottom: 1px solid #d4d4d4;
    }

    td:first-of-type {
      text-align: center;
    }
  }
}

.column {
  color: #666;
  cursor: pointer;
  font-weight: 400;
  min-width: 150px;
  position: relative;
  text-transform: uppercase;
  user-select: none;

  &.active {
    background: #d8d8d8;
    color: #000 !important;
  }
}

.arrow {
  font-size: 12px;
  position: absolute;
  right: 15px;
  top: 18px;
  transition: all 200ms ease-in-out;
}

.lang-selector {
  margin-left: auto;
  width: auto;
}
</style>